import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsxs("g", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M7.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 5.5858l3.2929-3.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "var(--neutral-500, #666666)",
                d: "M2 9c0-1.6569 1.3432-3 3-3h14c1.6569 0 3 1.3431 3 3v9c0 1.6569-1.3431 3-3 3H5c-1.6568 0-3-1.3431-3-3zm3-1c-.5523 0-1 .4477-1 1v9c0 .5523.4477 1 1 1h14c.5523 0 1-.4477 1-1V9c0-.5523-.4477-1-1-1z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M15.2111 12.606c.7371.3685.7371 1.4203 0 1.7888l-3.7639 1.882c-.6649.3324-1.4472-.1511-1.4472-.8944v-3.764c0-.7433.7823-1.2268 1.4472-.8944z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M14.7638 13.5004 11 11.6185v3.7639zm-3.3166 2.7764c-.6649.3324-1.4472-.1511-1.4472-.8944v-3.764c0-.7433.7823-1.2268 1.4472-.8944l3.7639 1.882c.7371.3685.7371 1.4203 0 1.7888z"
            })
        ]
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "DeviceTV", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
